export default {
  title: 'Menuwijzigingsgeschiedenis',
  subtitle: 'Bekijk wie prijzen, beschikbaarheid en zichtbaarheid voor {{company}} heeft gewijzigd — en wanneer.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Alle items',
    },
    event: {
      label: 'Gebeurtenis',
    },
  },
  columns: {
    when: 'Wanneer',
    who: 'Gewijzigd door',
    type: 'Type',
    item: 'Item',
    event: 'Gebeurtenis',
    changes: 'Wijzigingen',
  },
  types: {
    product: 'Product',
    modifier: 'Modifier',
    category: 'Categorie',
    modifier_group: 'Modifiergroep',
    menu: 'Menu',
  },
  events: {
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    deleted: 'Verwijderd',
  },
  fields: {
    name: 'Naam',
    description: 'Beschrijving',
    price: 'Prijs',
    is_available: 'Beschikbaarheid',
    is_visible: 'Zichtbaarheid',
    is_available_for_pickup: 'Afhaal beschikbaarheid',
    is_available_for_delivery: 'Bezorg beschikbaarheid',
    tax_category_id: 'Belastingcategorie',
    schedule: 'Weergavetijden',
    is_required: 'Verplicht',
    max_count: 'Max. keuzes',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Afhaalprijs',
    delivery: 'Bezorgprijs',
    dine_in: 'Prijs ter plaatse',
    room_service: 'Roomservice-prijs',
  },
  booleans: {
    on: 'Beschikbaar',
    off: 'Niet beschikbaar',
    yes: 'Ja',
    no: 'Nee',
  },
  schedule: {
    always: 'Altijd',
    every_day: 'Elke dag',
  },
  pagination: {
    previous: 'Vorige',
    next: 'Volgende',
  },
  causers: {
    undo: 'Ongedaan maken',
    orders_terminal: 'Bestellingsterminal',
    approved_by: {
      amigo: 'Amigo, goedgekeurd door {{name}}',
      assistant: 'Assistent, goedgekeurd door {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Openen in het Amigo-logboek',
  system: 'Systeem',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menuwijzigingsgeschiedenis laden mislukt',
  },
};
